export const contactsData = {
    email: 'marko_tomik@hotmail.com',
    address: 'Tartu, Estonia',
    sheetAPI: ''
}
